import { Theme } from "@mui/material/styles";

export default function Avatar(theme: Theme) {
    return {
        MuiAvatar: {
            styleOverrides: {
                colorDefault: {
                    color: theme.palette.common.white,
                    backgroundColor: "#d0c6b2",
                    fontFamily: theme.typography.fontFamilyHeading,
                    fontSize: theme.typography.pxToRem(14),
                    fontWeight: 700,
                },
            },
        },
        MuiAvatarGroup: {
            styleOverrides: {
                avatar: {
                    fontSize: 16,
                    fontWeight: theme.typography.fontWeightMedium,
                    "&:first-of-type": {
                        fontSize: 14,
                        color: theme.palette.primary.main,
                        backgroundColor: theme.palette.primary.lighter,
                    },
                },
            },
        },
    };
}
